// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicRightOutlinedSvg from "@ant-design/icons-svg/es/asn/PicRightOutlined";
import AntdIcon from '../components/AntdIcon';

var PicRightOutlined = function PicRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicRightOutlinedSvg
  }));
};

PicRightOutlined.displayName = 'PicRightOutlined';
export default React.forwardRef(PicRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PicRightOutlined.js
// module id = 1563
// module chunks = 0